module.exports = __webpack_public_path__ + "assets/a156b72c6e7cfac22942fac68601503e.png";